module.exports = __webpack_public_path__ + "static/features-autopilot-c9d197686da3a2a35c8be1ebc283718b.png";